<template>
  <div class="edu-home">
    <div class="item-box-430 basic-info">
      <Row>
        <Col :span="3">
          <img v-if="logoId!=0&&logoId" class="logo" :src="downloadUrl+'?fileId='+logoId" alt="">
          <img v-else class="logo" :src="defaultLogo" alt="">
        </Col>
        <Col :span="16">
          <span class="title-name">{{ baseInfo.name||'-' }}</span>
          <div class="info-content">
            <Form label-position="left">
              <Row>
                <Col :span="12">
                  <FormItem label="单位类型">
                    教育局
                  </FormItem>
                </Col>
                <Col :span="12">
                  <FormItem label="单位账号类别">
                    {{ orgKindList[coInfo.orgKind]||'-' }}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :span="12">
                  <FormItem label="合作状态">
                    {{ cooperationList[coInfo.coSts] ||'-' }}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :span="12">
                  <FormItem label="单位联系人">
                    {{ baseInfo.contactName||'-' }}（{{ baseInfo.contactPhoneNo||'-' }}）
                  </FormItem>
                </Col>
                <Col :span="12">
                  <FormItem label="创建时间和创建人">
                    {{ baseInfo.operateTime||'-' }}|{{ baseInfo.creatorName||'-' }}
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col :span="16">
                  <FormItem label="更新时间和经手人">
                    {{ baseInfo.operateTime||'-' }}|{{ baseInfo.operatorName||'-' }}
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
        <Col :span="5">
          <Button class="back" type="primary" @click="back">返回上一步</Button>
        </Col>
      </Row>
    </div>
    <DataInfoBlock :info-format="baseInfoFormat"></DataInfoBlock>
    <DataInfoBlock :info-format="coInfoFormat"></DataInfoBlock>
    <DataInfoBlock :info-format="dtlInfoFormat"></DataInfoBlock>
    <div class="mainNav item-box-430 basic-info">
      <Tabs value="name2">
        <TabPane label="服务统计" name="name2">
          <div class="table">
            <Table border :columns="jgcolumns" :data="jgdata">
              <template slot="orgType" slot-scope="{ row }">
                <span>{{ row.orgType | InitOrgType() }}</span>
              </template>
              <template slot="reviewState" slot-scope="{ row }">
                <span>{{ row.reviewState | InitReviewState() }}</span>
              </template>
              <template slot="orgSts" slot-scope="{ row }">
                <div>
                  <span :class="row.orgSts == 1 ? 'green' : 'purple'"></span><span>{{ row.orgSts | InitOrgSts() }}</span>
                </div>
              </template>
            </Table>
            <div class="paging">
              <Page
                :total="pageInfo.count"
                show-total
                show-elevator
                :current="pageInfo.page"
                :page-size="pageInfo.size"
                @on-change="handlePageChangeOrg"
              ></Page>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
<script>
import operation from '@/request/operationAdmin/index.js';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import { orgKindList, cooperationList, completeStatusList, orgEduRankList, changeDictionaries, baseInfoFormat, coInfoFormat,
  dtlInfoFormat } from '@/utils/dictionary.js';
import DataInfoBlock from '@/pages/assetsModules/DataInfo/DataInfoBlock.vue';
export default {
  components: {
    DataInfoBlock
  },
  filters: {
    InitOrgType(v) {
      switch (v) {
        case 1:
          return '民企';
        case 2:
          return '国企';
        case 3:
          return '个体';
        case 4:
          return '其他';
      }
    },
    InitOrgSts(v) {
      switch (v) {
        case 1:
          return '运营中';
        case 2:
          return '已停止合作';
      }
    },
    InitReviewState(v) {
      switch (v) {
        case 1:
          return '审批通过';
        case 0:
          return '审批中';
        case 2:
          return '审批驳回';
      }
    }
  },
  data() {
    return {
      orgId: '', // 教育局的id
      logoId: '', // logoid
      defaultLogo: require('@/assets/img/icon_logo.png'), // 默认图片
      downloadUrl: '', // logoid
      baseInfo: {}, // 教育局基本信息
      eduInfo: {}, // 教育局信息
      coInfo: {}, // 合作信息
      dtlInfo: {}, // 详细信息
      legalInfo: {}, // 法人信息
      contactInfo: {}, // 联系信息
      baseInfoFormat: { ...baseInfoFormat },
      coInfoFormat: { ...coInfoFormat },
      dtlInfoFormat: { ...dtlInfoFormat },
      orgKindList: changeDictionaries(orgKindList), // 单位类别列表
      cooperationList: changeDictionaries(cooperationList), // 合作状态列表
      completeStatusList: changeDictionaries(completeStatusList), // 信息完善状态
      orgEduRankList: changeDictionaries(orgEduRankList), // 单位级别
      /* 服务统计 */
      jgcolumns: [
        {
          title: '序号',
          key: 'orgId'
        },
        {
          title: '服务名称',
          key: 'orgName'
        },
        {
          title: '校区数（个）',
          key: 'mount'
        },
        {
          title: '服务学校数（个）',
          key: 'serviceschool'
        },
        {
          title: '服务类型',
          slot: 'orgType'
        },
        {
          title: '服务状态',
          slot: 'orgSts'
        },
        {
          title: '审批状态',
          slot: 'reviewState'
        },
        {
          title: '法定代表人',
          key: 'corporation'
        }
      ],
      /* 服务统计 */
      pageInfo: {
        page: 1,
        count: 0,
        size: 10
      },
      jgdata: [] // 服务统计
    };
  },
  created() {
    this.getUrlToken();
    this.orgId = this.$route.query.orgId ? this.$route.query.orgId : '';
    this.getEduDetails();
    this.getEduOrgDetail();
  },
  methods: {
    // 点击返回上一页
    back() {
      this.$router.go(-1);
    },
    // 上传token
    async getUrlToken() {
      const res = await cateringAdmin.getUploadtoken();
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
      }
    },
    // 获取教育局详情
    async getEduDetails() {
      const params = {
        orgId: this.orgId // 教育局id
      };
      const res = await operation.getEduDetailsNew(params);
      if (res.status === 200) {
        console.log(res.message);
        this.logoId = res.message.logoId;
        this.baseInfo = res.message.baseInfo;
        this.eduInfo = res.message.eduInfo;
        this.coInfo = res.message.coInfo;
        this.dtlInfo = res.message.dtlInfo;
        this.dealBaseInfo(res.message.baseInfo);
        this.dealCoInfoFormat(res.message.coInfo);
        this.dealDtlInfoFormat(res.message.dtlInfo);
      }
    },
    // 处理基础数据
    dealBaseInfo(baseInfo) {
      this.baseInfoFormat.list.forEach(item => {
        switch (item.key) {
          case 'orgLevel':
            item.value = this.orgEduRankList[baseInfo.orgLevel];
            break;
          default:
            item.value = baseInfo[item.key];
            break;
        }
      });
    },
    // 处理合作信息
    dealCoInfoFormat(coInfo) {
      this.coInfoFormat.list.forEach(item => {
        switch (item.key) {
          case 'orgKind':
            item.value = this.orgKindList[coInfo.orgKind];
            break;
          case 'coSts':
            item.value = this.cooperationList[coInfo.coSts];
            break;
          default:
            item.value = coInfo[item.key];
            break;
        }
      });
    },
    // 处理详细信息
    dealDtlInfoFormat(dtlInfo) {
      this.dtlInfoFormat.list.forEach(item => {
        switch (item.key) {
          default:
            item.value = dtlInfo[item.key];
            break;
        }
      });
    },
    // 教育局-服务统计
    async getEduOrgDetail() {
      const params = {
        bureauId: this.orgId,
        pageNum: this.pageInfo.page,
        pageSize: 10
      };
      const res = await operation.geteduOrgNew(params);
      if (res.status === 200) {
        this.jgdata = res.message.list;
        this.pageInfo.count = Number(res.message.total);
      } else {
        this.$Message.error(res.message);
      }
    },
    // 服务统计-分页
    handlePageChangeOrg(v) {
      this.pageInfo.page = v;
      this.getEduOrgDetail();
    }
  }
};
</script>
<style lang="scss" scoped>
.edu-home {
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  .title-name{
    font-size:24px;
    font-weight: bold;
  }
  .logo{
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .info-content{
    padding-top: 16px;
    // /deep/.ivu-row{
    //   margin: 10px 0;
    // }
    /deep/.ivu-form-item{
      label{
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
  .edu-item-title{
    font-size: 16px;
    font-weight: 500;
    padding-bottom: 16px;
    border-bottom: 1px solid #ccc;
  }
}
.mainNav {
  margin-top: 20px;
  margin-bottom: 40px;
  .tab1Item {
    width: 100%;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    .tab1Item_tit {
      line-height: 50px;
      background: #f5f7f9;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 600;
      color: #666;
    }
    .tab1Item_con {
      background: #fff;
      padding: 20px;
      line-height: 30px;
    }
  }
}
.basic-info {
  background: #fff;
  border-radius: 10px;
  box-shadow: 2px 2px 4px 2px #e8e8e8;
  margin-bottom: 20px;
}
</style>
